var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inline)?_c('div',{staticClass:"editable",attrs:{"id":_vm.domId}},[_vm._v(_vm._s(_vm.content))]):_c('textarea',{staticClass:"editable",attrs:{"id":_vm.domId}},[_vm._v(_vm._s(_vm.content))])
}
var staticRenderFns = []

export { render, staticRenderFns }